import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, Form, FormBuilder, FormGroup, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';


export enum DateOption {
  MONTH = 0,
  YEAR = 1
}

export interface DateTaggleValue {
  year: number;
  month: number;
}
@Component({
  selector: 'split-input-date-taggle',
  templateUrl: './split-input-date-taggle.component.html',
  styleUrls: ['./split-input-date-taggle.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SplitInputDateTaggleComponent),
    multi: true
  }]
})
export class SplitInputDateTaggleComponent implements OnInit {


  protected options: any[] = [
    { label: 'Mês a mês', value: DateOption.MONTH },
    { label: 'Anual', value: DateOption.YEAR }
  ];

  protected dateOptions: any[] = [];

  protected form!: FormGroup;

  @Input() public formGroupName!: string;

  private readonly MONTH = [
    `01 - 31 Janeiro`,
    `01 - 28 Fevereiro`,
    `01 - 31 Março`,
    `01 - 30 Abril`,
    `01 - 31 Maio`,
    `01 - 30 Junho`,
    `01 - 31 Julho`,
    `01 - 31 Agosto`,
    `01 - 30 Setembro`,
    `01 - 31 Outubro`,
    `01 - 30 Novembro`,
    `01 - 31 Dezembro`
  ];



  constructor(
    private formGroupDirective: FormGroupDirective) { }


  ngOnInit(): void {
    this.form = this.formGroupDirective.control.get(this.formGroupName) as FormGroup;
    this.loadDateOptions();
  }

  onOptionClick(option: any) {
    if(option == DateOption.YEAR) {
        let value = this.form.get('date')?.value;
        this.form.get('date')?.setValue({ ...value, month: -1});
    } else {
        let now = new Date();
        this.form.get('date')?.setValue({ year: now.getFullYear(), month: now.getMonth() });
    }
    this.loadDateOptions();
  }

  addNewFilterEvent() {
    let value = this.form.get('date')?.value;
    console.log('value: ', value);
  }

  loadDateOptions() {
    let option = this.form.get('option')?.value;
    const today = new Date();
    let currentMonth = today.getMonth();
    let currentYear = today.getFullYear();
    this.dateOptions = [];
    if(option == DateOption.MONTH) {
      for (let i = 0; i < 12; i++) {
        this.dateOptions.push({ 
          label: `${this.MONTH[currentMonth]} - ${currentYear}`, 
          value: { year: currentYear, month: currentMonth }
        })
        currentMonth--;
        if (currentMonth < 0) {
          currentMonth = 11;
          currentYear--;
        }
      }
    } else {
      this.dateOptions = [
        { label: `${currentYear}`, value: { year: currentYear, month: -1 } },
        { label: `${currentYear! - 1}`, value: { year: currentYear! - 1, month: -1 } },
        { label: `${currentYear! - 2}`, value: { year: currentYear! - 2, month: -1 } },
        { label: `${currentYear! - 3}`, value: { year: currentYear! - 3, month: -1 } },
        { label: `${currentYear! - 4}`, value: { year: currentYear! - 4, month: -1 } },
      ]
    }
  }
}
